// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
    height: 100%;
    overflow: hidden;
}

.html-js-content {
    height: calc(100% - 99px);
    position: relative;
    font-family: "roboto";
    color: #313541;
    padding: 5px 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-html-js/sem-html-js.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".input-wrapper {\r\n    height: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.html-js-content {\r\n    height: calc(100% - 99px);\r\n    position: relative;\r\n    font-family: \"roboto\";\r\n    color: #313541;\r\n    padding: 5px 30px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
